<div style="font-size: 16px !important">
    <div nz-row class="mt-2 consumer-section">
        @if(!isTimeOff) {
        <div nz-col nzSpan="24" class="mt-1">
            <div nz-row>
                <div nz-col nzSpan="8" ngClass="font-weight-600 pt-1 pb-2">
                    Participant Name:
                </div>
                <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{lineItem.consumerName}}</div>
            </div>
        </div>

        <div nz-col nzSpan="24" class="mt-1">
            <div nz-row>
                <div nz-col nzSpan="8" ngClass="font-weight-600 pt-1 pb-2">
                    Participant PPL ID:
                </div>
                <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{lineItem.consumerPplId}}</div>
            </div>
        </div>
        }

        <div nz-col nzSpan="24" class="mt-1">
            <div nz-row>
                <div nz-col nzSpan="8" ngClass="font-weight-600 pt-1 pb-2">
                    Provider Name:
                </div>
                <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{rowData.providerName}}</div>
            </div>
        </div>

        <div nz-col nzSpan="24" class="mt-1">
            <div nz-row>
                <div nz-col nzSpan="8" ngClass="font-weight-600 pt-1 pb-2">
                    Provider PPL ID
                </div>
                <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{rowData.providerPplId}}</div>
            </div>
        </div>
    </div>

    @if(mode == 'view' && !isTimeOff && !isReadOnly) {
    <div class="custom-row edit-button">
        <ppl-button label="Edit" icon="fa fa-pencil" [customClass]="'ghost-button'" [iconPosition]="'left'"
            (click)="onEdit()"></ppl-button>
    </div>
    }
    @if(mode == 'view') {
    @if(viewTimeoffData.length > 0) {
    <div class="p-1">
        <ppl-list-table class="ppl-table-container"
            [disableSort]="true"
            [disableSearch]="true"
            [showCustomSearch]="false"
            [enableActions]="(timesheetFor==='staff')"
            [data]="viewTimeoffData"
            (rowDetailEventTs)="rowClickedTs($event)"
            (rowDetailEvent)="rowClicked($event)"
            (selectionChanged)="selectionChanged($event)"
            (gridAction)="onAction($event)"
            [disableSelection]="false"
            [cols]="timeoff_cols"
            [gridTitle]="false"
            [pagination]="true"
            [loadPage]="false"
            [showExpandIcon]="true"
            [actionButtons]="actionButtons"
            [showLineItem]="true"
            [lineItemCols]="timeoff_cols"
            [showLineItemActions]="false"
            [cellClassResolver]="cellClassResolver"
            [timesheetFor]="timesheetFor">
        </ppl-list-table>
    </div>

    @if(!isProviderView && !isReadOnly) {
    <div class="custom-row" style="width: 100%;">
        <ppl-button (click)="onProcessClick()" [styleString]="'margin-right: 8px;'" label="Submit for Processing"
            icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
    </div>
    }
    }}
    @else {
    <ppl-timesheets-add-entries [entryType]="timeEntry" [payPeriod]="filetredPayPeriod" [consumers]="consumers"
        [action]="action" [timesheetData]="timesheetData" [staffView]="true"
        (timesheetAdded)="timesheetAdded($event)" (onClose)="onCancel($event)"></ppl-timesheets-add-entries>
    }
</div>

<div class="filter-panel">
    <ng-template #pendedDialog let-cancel="cancel">
        <ppl-timesheet-staff-errorcode [errorcodeData]="errorcodeData"
            (onSaveComplete)="onSaveAdjustment($event)" [disabled]="disableEditingPendedTimesheet"></ppl-timesheet-staff-errorcode>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #deniedDialog let-cancel="cancel">
        <ppl-timesheet-staff-deniedreasons [deniedData]="deniedData"></ppl-timesheet-staff-deniedreasons>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #authDataDialog let-cancel="cancel">
        <ppl-timesheet-staff-authdata [authData]="authData"
            (showAuthDetails)="showAuthDetails($event)"></ppl-timesheet-staff-authdata>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #authDialog let-cancel="cancel">
        <ppl-authorization-details [authorizationId]="selectedAuthorizationId" [pageSource]="'timesheet'" [isReadOnly]="true"></ppl-authorization-details>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #timesheetEditHistoryDialog let-cancel="cancel">
        <ppl-timesheet-edit-history-view [timesheetId]="selectedTimesheetId"></ppl-timesheet-edit-history-view>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #timesheetAuthHistoryDialog let-cancel="cancel">
        <ppl-audit-history [auditEntryId]="selectedTimesheetId" [flow]="'timesheet'" [programCode]="programName"></ppl-audit-history>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #derivedElementsDialog let-cancel="cancel">
        @if(derivedElementsData) {
        <table class="derived-elements-table">
            <thead>
                <tr>
                    <th>Category</th>
                    <th>Gross</th>
                    <th>Markup</th>
                    <th>Net</th>
                </tr>
            </thead>
            <tbody>
                @for(item of derivedElementsData.taxElements; track $index) {
                <tr>
                    <td>{{ item.category }}</td>
                    <td>{{ item.gross | currency }}</td>
                    <td>{{ item.markup }}%</td>
                    <td>{{ item.net | currency }}</td>
                </tr>
                }
                <tr>
                    <td colspan="2"></td>
                    <td class="font-weight-600">Total tax</td>
                    <td>{{ derivedElementsData.taxAmount | currency }}</td>
                </tr>
                <tr>
                    <td colspan="2"></td>
                    <td class="font-weight-600">Gross</td>
                    <td>{{ derivedElementsData.grossWage | currency }}</td>
                </tr>
                <tr>
                    <td colspan="2"></td>
                    <td class="font-weight-600">Billable</td>
                    <td>{{ derivedElementsData.billable | currency }}</td>
                </tr>
            </tbody>
        </table>
        }
    </ng-template>
</div>